import NavBar1 from "../components/navBar1";
const axios = require('axios').default;

export default function Music() {
    let queue = [];
    let current = 0;
    let track = {}

    async function search() {
        axios.get(`https://express-1.stevanvincent.repl.co/search/${encodeURIComponent(document.getElementById('search').value)}`)
            .then(function (response) {
                const res = response.data.filter(x => x.duration && x.title && x.type === 'video')
                queue.push({
                    'title': res[0].title,
                    'duration': res[0].duration,
                    'id': res[0].id
                })
                searchMenu()
                if (document.querySelector('#audio').paused || !document.querySelector('#audio').currentTime) play();
            })
    }

    function searchMenu() {
        document.querySelector('#searchMenu').classList.toggle('hidden')
        document.getElementById('search').value = ''
    }

    function putTrack() {
        document.querySelector('source').src = `https://express-1.stevanvincent.repl.co/track/${track.id}`
    }

    function nextTrack() {
        ++current
        track.title = queue[current - 1].title
        track.id = queue[current - 1].id
        track.duration = queue[current - 1].duration
    }

    function playNextTrack() {
        if (queue.length === current) return;
        nextTrack();
        putTrack();
        playTrack()
    }

    function playTrack() {
        document.querySelector('#audio').load();
        document.querySelector('#audio').play();
        document.querySelector('#title').textContent = queue[current - 1].title
        document.querySelector('#duration').textContent = queue[current - 1].duration
        document.querySelector('#ytImg').src = `https://i.ytimg.com/vi/${queue[current - 1].id}/hq720.jpg`
    }


    function volume() {
        document.querySelector("#volume").addEventListener("change", function (e) {
            document.querySelector('#audio').volume = e.currentTarget.value / 100;
        })
    }

    function play() {
        if (!queue.length) return alert('Please queue some music');
        document.querySelector('#play').classList.add('hidden')
        document.querySelector('#pause').classList.remove('hidden')
        if (document.querySelector('#audio').paused && document.querySelector('#audio').currentTime)
            return document.querySelector('#audio').play();
        if (document.querySelector('#audio').paused && !document.querySelector('#audio').currentTime) {
            nextTrack()
            putTrack()
            document.querySelector('#audio').volume = 0.5;
        }
        playTrack()
    }

    function pause() {
        if (document.querySelector('#audio').paused || !document.querySelector('#audio').currentTime) return;
        document.querySelector('#play').classList.remove('hidden')
        document.querySelector('#pause').classList.add('hidden')
        document.querySelector('#audio').pause()
    }

    return (
        <>
            <NavBar1></NavBar1>
            <div className="flex justify-center items-center h-screen" >
                <img id="ytImg" src="/p.png" alt="icon" className="h-auto lg:h-screen w-screen bg-cover bg-center opacity-60" />
            </div >
            <div className="w-screen fixed bottom-10 flex justify-center">
                <div>
                    <div className="p-10 overflow-hidden grid gap-1">
                        <p id="title" className="text-3xl w-3/4 truncate ... text-gray-200 font-outfit font-bold">Nothing playing</p>
                        <p id="duration" className="truncate ... text-gray-300 font-outfit"></p>
                        <input onInput={volume} id="volume" type={'range'} className="slider2 mb-16 cursor-pointer transition duration-500 opacity-70 hover:opacity-100 mt-5"></input>
                    </div>
                    <div className="flex gap-x-14 px-16 justify-center items-center">
                        <div onClick={searchMenu} className="cursor-pointer">
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-10 w-10 text-gray-200/70 transition duration-300 hover:text-gray-200/100" viewBox="0 0 20 20" fill="currentColor">
                                <path fillRule="evenodd" d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z" clipRule="evenodd" />
                            </svg>
                        </div>
                        <div onClick={play} id="play" className="cursor-pointer">
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-16 w-16 text-gray-200/70 transition duration-300 hover:text-gray-200/100" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z" />
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                            </svg>
                        </div>
                        <div onClick={pause} id="pause" className="hidden cursor-pointer">
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-16 w-16 text-gray-200/70 transition duration-300 hover:text-gray-200/100" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 9v6m4-6v6m7-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                            </svg>
                        </div>
                        <div className="cursor-pointer">
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-10 w-10 text-gray-200/70 transition duration-300 hover:text-gray-200/100" viewBox="0 0 20 20" fill="currentColor">
                                <path fillRule="evenodd" d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z" clipRule="evenodd" />
                            </svg>
                        </div>
                    </div>
                </div>
            </div>

            {/* search */}
            <div id="searchMenu" className="hidden">
                <div className="fixed top-0 bg-[#111827]/80 w-screen h-screen z-50">
                    <div className="flex justify-center items-center">
                        <svg onClick={searchMenu} xmlns="http://www.w3.org/2000/svg" className="h-12 w-12 text-gray-200/70 transition duration-300 hover:text-gray-200 cursor-pointer" viewBox="0 0 20 20" fill="currentColor">
                            <path fillRule="evenodd" d="M7.707 14.707a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l2.293 2.293a1 1 0 010 1.414z" clipRule="evenodd" />
                        </svg>
                        <div className="p-6">
                            <form onSubmit={search} className="flex items-center gap-3 outline outline-3 px-2 py-3 rounded-2xl outline-gray-200">
                                <input autoComplete="off" placeholder="Search..." id="search" className="rounded-md bg-transparent focus:outline-none select-auto text-gray-200"></input>
                                <button>
                                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-gray-200/70 transition duration-300 hover:text-gray-200/100" viewBox="0 0 20 20" fill="currentColor">
                                        <path fillRule="evenodd" d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z" clipRule="evenodd" />
                                    </svg>
                                </button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>

            {/* audio */}
            <audio onEnded={playNextTrack} id="audio">
                <source src="" type="audio/ogg"></source>
                <source src="" type="audio/mpeg"></source>
                Your browser does not support the audio format.
            </audio>
        </>
    )
}